export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";